
import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import { useNavigate } from "react-router-dom";

function AdminNavbar() {
    const location = useLocation();
    const { logout } = useAuth();
    const navigate = useNavigate();

    const handleLogout = () => {
        logout();
        navigate("/login");
    };

    const isActive = (path) => {
        if (path === "/dashboard" && location.pathname === "/dashboard") return true;
        if (path !== "/dashboard" && location.pathname.includes(path)) return true;
        return false;
    };

    const navItems = [
        { path: "/dashboard", label: "Trips", icon: "🚤" },
        { path: "dashboard/MarineServes", label: "Marine Services", icon: "⚓" },
        { path: "dashboard/Comments", label: "Comments", icon: "💬" },
        { path: "dashboard/Special", label: "Special Trips", icon: "✨" },
        { path: "dashboard/Cambing", label: "Camping", icon: "🏕️" },
        { path: "dashboard/Course", label: "Courses", icon: "🎓" },
        { path: "dashboard/Reports", label: "Reports", icon: "📊" },
        { path: "dashboard/Prices", label: "Prices", icon: "💰" },
    ];

    return (
        <nav className="bg-gradient-to-r from-blue-800 via-blue-700 to-cyan-700 text-white shadow-2xl sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 py-3">
                {/* Top Row - Logo and Logout */}
                <div className="flex justify-between items-center mb-3">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-full bg-white/20 flex items-center justify-center text-2xl">
                            🦈
                        </div>
                        <div>
                            <h1 className="text-xl font-bold tracking-wide">Blue Shark</h1>
                            <p className="text-xs text-cyan-200">Admin Dashboard</p>
                        </div>
                    </div>
                    <button 
                        onClick={handleLogout}
                        className="flex items-center gap-2 px-4 py-2 bg-red-500/20 hover:bg-red-500/40 
                            rounded-lg transition-all duration-300 text-sm border border-red-400/30"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
                        </svg>
                        Logout
                    </button>
                </div>

                {/* Navigation Links */}
                <div className="flex flex-wrap gap-2">
                    {navItems.map((item) => (
                        <Link 
                            key={item.path}
                            to={item.path} 
                            className={`flex items-center gap-1.5 px-3 py-2 rounded-lg text-sm font-medium
                                transition-all duration-300 ${
                                isActive(item.path) 
                                    ? 'bg-white text-blue-700 shadow-lg' 
                                    : 'hover:bg-white/20 text-white/90'
                            }`}
                        >
                            <span>{item.icon}</span>
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </div>
            </div>

            {/* Decorative Wave */}
            <div className="h-1 bg-gradient-to-r from-cyan-400 via-blue-400 to-cyan-400"></div>
        </nav>
    );
}

export default AdminNavbar;